import { DashboardDto } from "@features/results/Result/Dashboard/dashboardModel"
import { load } from "js-yaml"
import { v4 } from "uuid"

export const loadDashboard = (value: string): DashboardDto => {
  const dashboard = load(value) as DashboardDto
  const resultGroups = dashboard.Groups ?? []
  const compareResultsGroups = dashboard.CompareResults?.Groups ?? []

  resultGroups.forEach((group) => {
    group.Charts.forEach((chart) => {
      chart.uid = v4()
      chart.isCompareResultsChart = false
    })
  })

  compareResultsGroups.forEach((group) => {
    group.Charts.forEach((chart) => {
      chart.uid = v4()
      chart.isCompareResultsChart = true
    })
  })

  return dashboard
}
